<script setup lang="ts">
	import { ref } from 'vue';
	import SortableList from './SortableList.vue';
	import { SortableItem } from './SortableItem.js'
	
	const props = defineProps({
		list1: Array,
		list2: Array
	});
	
	const listId1 = ref(null);
	const listId2 = ref(null);
	
	function removeFrom(item: SortableItem): void {
		if (item.fromList==="listId1") { listId1.value.removeFrom(item); }
		else if (item.fromList==="listId2") { listId2.value.removeFrom(item); }
	}
	
	function onDragEnd(evt) {
		listId1.value.removePreview(true);
		listId2.value.removePreview(true);
	}
	
</script>
<template>
	<div class="sortableBox" @dragend='onDragEnd'>
		<sortable-list ref="listId1" class="sortingBlock column-selected ui-sortable sortableItem"
					   id="listId1" :items="list1" @remove-from="removeFrom" />
		<slot></slot>
		<sortable-list ref="listId2" class="sortingBlock column-selected ui-sortable sortableItem"
					   id="listId2" :items="list2" @remove-from="removeFrom" />
	</div>
</template>

<style>
	.sortableBox {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-between;
		align-items: center;
	}
	
	.sortableItem {
		min-width: 150px;
	}
</style>
